import React from 'react'
import Flow from 'procedures/Flow'
import {get, isEmpty} from 'lodash'
import {getAddedDependents} from 'procedures/changeDependents/utils'

export const makeFlow = function* (employee, procedureStatus, flowStatus) {
  if (isEmpty(employee) || isEmpty(employee.office) || isEmpty(procedureStatus)) {
    return
  }
  const healthInsuranceJoined = get(employee, 'health_insurance.joined')
  const welfarePensionInsuranceJoined = get(employee, 'welfare_pension_insurance.joined')
  const healthInsuranceType = get(employee, 'office.health_insurance_type')
  const dependents = getAddedDependents(employee.employee_dependents, procedureStatus)
  const spouse = dependents.find((dependent) => dependent.relation_type === 'spouse')
  const others = dependents.filter((dependent) => dependent.relation_type !== 'spouse')

  if (healthInsuranceJoined) {
    if (healthInsuranceType === 'its' && !flowStatus.skipItsDependentsReports) {
      if (spouse) {
        yield `R150_${spouse.id}`
      }
      yield* others.map((dependent) => `R150_${dependent.id}`)
    }
    if (!isEmpty(dependents)) {
      if (healthInsuranceType === 'its') {
        yield 'R5'
      } else {
        yield 'R4'
      }
    }
  }
  if (welfarePensionInsuranceJoined && spouse) {
    if (healthInsuranceType !== 'kyokai') {
      yield 'R6'
    }
  }
  if (welfarePensionInsuranceJoined && spouse && spouse.national_type === 'foreigner') {
    yield 'R56'
  }
  return
}

const AddDependentFlow = ({location, match}) => (
  <Flow {...{makeFlow, location, match}} embed="procedure_add_dependents_data" />
)

export default AddDependentFlow
